import { Alert } from '@/components/ui/alert'
import type { Blast, BlastDeliveryGate } from '@/pages/BlastsPage.types'

export function blastDeliveryPageState(
  data: { blasts: Blast[]; delivery_gate: BlastDeliveryGate } | undefined,
  error: Error | null,
) {
  return {
    error,
    zeroRecipientSubject: data?.blasts.find((blast) => blast.zero_recipient)?.subject,
    gate: data?.delivery_gate,
    deliveryEnabled: data?.delivery_gate?.enabled ?? false,
  }
}

export function BlastDeliveryGateNotice({
  error,
  zeroRecipientSubject,
  gate,
}: {
  error: Error | null
  zeroRecipientSubject: string | undefined
  gate: BlastDeliveryGate | undefined
}) {
  const deliveryBlocked = gate && !gate.enabled
  if (!error && !zeroRecipientSubject && !deliveryBlocked) return null

  return (
    <div className="space-y-2">
      {error || zeroRecipientSubject ? (
        <Alert>{error?.message ?? `Sent to 0: ${zeroRecipientSubject}`}</Alert>
      ) : null}
      {deliveryBlocked ? (
        <Alert variant="warning">
          {gate.explanation}{' '}
          <a className="font-medium underline" href={gate.setup_path}>
            Set up Sending Domain
          </a>
        </Alert>
      ) : null}
    </div>
  )
}
